import { fonts } from "theme/themeConfig"
import { fontVariants } from "../fontVariants"

export const Center = {
  baseStyle: {
    fontFamily: fonts.demi,
    fontWeight: "medium",
  },
  variants: {
    ...fontVariants,
    share: {
      ...fontVariants.book1,
      position: "absolute",
    },
  },
}
